import { BOOK_DEMO_URL } from "@/lib/constants";
import { Button } from "@/components/ui/Button";
import { Icon } from "@/components/ui/Icon";
import { IconName } from "@/components/ui/Icon/names";
import React from "react";
import { Text } from "@/components/ui/Text";
import { useProductTier } from "@/hooks/useProductTier";

interface EnterpriseGateProps {
  children?: React.ReactNode;
  icon?: IconName;
  title?: string;
  description?: string;
  allowed?: boolean;
}

export function EnterpriseGate({
  children,
  icon = "lock",
  title = "Enterprise Feature",
  description = "This feature is available on the Enterprise plan. Book a time to get started.",
  allowed,
}: EnterpriseGateProps): React.JSX.Element {
  const productTier = useProductTier();

  if (allowed ?? (productTier === "enterprise" || productTier === "payg")) {
    return <>{children}</>;
  }

  return (
    <div className="bg-muted/20 m-8 flex flex-col items-center justify-center border border-dashed px-8 py-24">
      <div className="bg-muted/50 mb-4 flex h-12 w-12 items-center justify-center rounded-full">
        <Icon name={icon} className="text-muted-foreground h-6 w-6" />
      </div>
      <Text variant="subheading" className="mb-1">
        {title}
      </Text>
      <Text small muted className="mb-4 max-w-md text-center">
        {description}
      </Text>
      <Button variant="brand" asChild>
        <a href={BOOK_DEMO_URL} target="_blank" rel="noopener noreferrer">
          Talk to our team
        </a>
      </Button>
    </div>
  );
}
